import request from '@/utils/request'


/**
 * 恢复文件
 */
 export function restoreFile(formData) {
  return request({
    url: `/recycleBin/restore`,
    method: 'patch',
    data: formData
  })
}

/**
 * 彻底删除文件
 */
 export function deleteFile(formData) {
  return request({
    url: `/recycleBin/delete`,
    method: 'delete',
    data: formData
  })
}
